// @flow
import { FavOriginsActionTypes } from './constants';

type FavOriginsAction = { type: string, payload: {} | string };

// common success
export const favOriginsApiResponseSuccess = (actionType: string, data: any): FavOriginsAction => ({
    type: FavOriginsActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});
// common error
export const favOriginsApiResponseError = (actionType: string, error: string): FavOriginsAction => ({
    type: FavOriginsActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const getFavOrigin = (id: string): FavOriginsAction => ({
    type: FavOriginsActionTypes.GET_FAV_ORIGIN,
    payload: { id },
});

export const addFavOrigin = (favOrigin:any):FavOriginsAction=>({
    type:FavOriginsActionTypes.ADD_FAV_ORIGIN,
    payload:favOrigin
})
export const updateFavOrigin = (favOrigin:any):FavOriginsAction=>({
    type:FavOriginsActionTypes.UPDATE_FAV_ORIGIN,
    payload:favOrigin
})
export const deleteFavOrigin = (id:string):FavOriginsAction=>({
    type:FavOriginsActionTypes.DELETE_FAV_ORIGIN,
    payload:{id}
})

export const listFavOrigins = (params:any): FavOriginsAction => ({
    type: FavOriginsActionTypes.LIST_FAV_ORIGINS,
    payload: params,
});


export const resetFavOrigins = (): FavOriginsAction => ({
    type: FavOriginsActionTypes.RESET,
    payload: {},
});

